export enum Theme {
  NORMAL,
  UPSTART,
  NEW_DESIGN,
}
